/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const usePaymentForm = () => {
  const [condicaoPagamentos, setCondicaoPagamentos] = useState<
    CondicaoPagamento[]
  >([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] =
    useState<CondicaoPagamento>(null);
  const [nome, setNome] = useState("");
  const [parcelas, setParcelas] = useState(0);
  const [baixaPrimeira, setBaixaPrimeira] = useState(false);
  const [entrada, setEntrada] = useState(false);
  const [diaFixo, setDiaFixo] = useState(0);

  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const cancelRef = useRef();

  const closeError = () => {
    setError(false);
  };

  const changeInput = (tipo: string, value: any) => {
    switch (tipo) {
      case "nome":
        setNome(value);
        break;
      case "parcelas":
        setParcelas(Number(value));
        break;
      case "baixaPrimeira":
        setBaixaPrimeira(Boolean(value));
        break;
      case "entrada":
        setEntrada(Boolean(value));
        break;
      case "diaFixo":
        setDiaFixo(Number(value));
        break;
      default:
        break;
    }
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const cleanInput = () => {
    setNome("");
    setParcelas(0);
    setBaixaPrimeira(false);
    setEntrada(false);
    setDiaFixo(0);
  };
  const add = () => {
    showModal(true);
  };

  const edit = (item: CondicaoPagamento) => {
    showModal(true);
    setAccountSelected(item);
    setNome(item.nome);
    setParcelas(item.parcelas);
    setBaixaPrimeira(Boolean(item.baixaPrimeira));
    setEntrada(Boolean(item.entrada));
    setDiaFixo(Number(item.diaFixo));
  };

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      setAccountSelected(null);
    }
  };

  const save = async () => {
    if (nome === "") {
      showError("Erro!", "Preencha Corretamente o campo nome");
      return;
    }

    if (parcelas === 0) {
      showError("Erro!", "Preencha Corretamente o campo parcelas");
      return;
    }


    if (!accountSelected) {
      await addRegister();
    } else {
      await updateRegister();
    }
    await loadData();
  };

  const addRegister = async () => {
    const obj = {
      nome: nome,
      parcelas: Number(parcelas),
      baixaPrimeira: baixaPrimeira,
      diaFixo: diaFixo,
      entrada: entrada,
      idEmpresa: usuario.idEmpresa,
    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/condicao-pagamento",
      obj
    );
    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      cleanInput();
    }
  };

  const updateRegister = async () => {
    const obj: CondicaoPagamento = {
      id: accountSelected.id,
      nome: nome,
      parcelas: Number(parcelas),
      baixaPrimeira: baixaPrimeira,
      diaFixo: diaFixo,
      entrada: entrada,
      idEmpresa: accountSelected.idEmpresa,
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/" + accountSelected.id,
      obj
    );

    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showModal(false);
      cleanInput();
      setAccountSelected(null);
    }
  };

  const showDeleteModal = (item: CondicaoPagamento) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/" + accountSelected?.id
    );
    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showModal(false);
      cleanInput();
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCondicaoPagamentos(response.data);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return {
    condicaoPagamentos,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    error,
    save,
    deletar,
    showDeleteModal,
    showDelete,
    cancelRef,
    closeDelete,
    changeInput,
    nome,
    parcelas,
    baixaPrimeira,
    entrada,
    diaFixo,
    errorTitle,
    errorMsg,
    closeError,
    showError,
  };
};

export default usePaymentForm;
